import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DarkScreenMask, ConfirmModal } from "../..";
import scoreboardColors from '../../styles/shared/scoreboardColors';
import close from "../../assets/imgs/icon-close.svg";
import "./LogoColorPicker.scss";

const LogoColorPicker = ({ isHomeTeam, logo, onChangeLogo, color, onChangeColor, onBack, onRemoveTeamColorAndImage }) => {
  const [hasLogo, setHasLogo] = useState(logo != null);
  const [confirmModalFlag, setConfirmModalFlag] = useState(false);

  const toggleConfirmModal = ()=> {
    setConfirmModalFlag(currentFlagStatus => !currentFlagStatus);
  };

  const handleRemoveTeamColorAndImage = ()=> {
    onRemoveTeamColorAndImage();
    toggleConfirmModal();
  }

  return (
    <div className="logo-color-picker">
      {/* <div className="logo-color-picker__preview">
      </div> */}
      <div className="logo-color-picker__close-wrapper">
        <button onClick={onBack} className="logo-color-picker__close-wrapper__button">
          <img src={close}/>
        </button>
      </div>
      <div className="logo-color-picker__pickers">
        <input
          type="file"
          accept="image/x-png,image/gif,image/jpeg"
          value=""
          id={`team-image-${isHomeTeam ? "home" : "away"}`}
          style={{ display: "none" }}
          onChange={(e)=> {
            onChangeLogo(e);
            onChangeColor(null);
          }}
          onClick={()=> {
            setHasLogo(true);
          }}
        />
        {/* eslint-disable */}
        <label htmlFor={`team-image-${isHomeTeam ? "home" : "away"}`}>
          <div className="logo-color-picker__pickers__image">
            <div className="logo-color-picker__pickers__image__title">
              <div className="logo-color-picker__pickers__image__title__circle"  >
                <div style={{ backgroundColor: hasLogo ?  "white" : 'transparent'  }} />
              </div>
              <span>Team Logo</span>
            </div>
            <div className="logo-color-picker__pickers__image__button">
              <span>Upload</span>
              <span>Team Logo</span>
            </div>
          </div>
        </label>
        {/* eslint-enable */}
        <div className="logo-color-picker__pickers__colors">
          <div className="logo-color-picker__pickers__colors__title">
            <div className="logo-color-picker__pickers__colors__title__circle">
              <div style={{ backgroundColor: hasLogo ? 'transparent' : "white" }} />
            </div>
            <span>Team Color</span>
          </div>
          <div className="logo-color-picker__pickers__colors__palette">
            {scoreboardColors.map(c =>
              <button
                key={c}
                type="button"
                className="logo-color-picker__pickers__colors__palette__button"
                style={{
                  borderColor: c === color ? "white" : "transparent",
                }}
                onClick={() => {
                  setHasLogo(false);
                  onChangeColor(c);
                  onChangeLogo(null);
                }}

              >
                <div
                  className="logo-color-picker__pickers__colors__palette__button__fill"
                  style={{ backgroundColor: c }}
                />
              </button>
            )}
          </div>
        </div>
      </div>
      <button
        onClick={toggleConfirmModal}
        className="logo-color-picker__back"
      >
        Remove logo/color
      </button>
      <DarkScreenMask isVisible={confirmModalFlag}>
        <ConfirmModal 
          onApprove={handleRemoveTeamColorAndImage}
          onDismiss={toggleConfirmModal}
          title={`Are you sure you want to remove ${isHomeTeam ? "home" : "away"} team logo and color?`}        
        />
      </DarkScreenMask>
    </div>
  );
};

LogoColorPicker.propTypes = {
  color: PropTypes.string,
  isHomeTeam: PropTypes.bool,
  logo: PropTypes.string,
  onBack: PropTypes.func,
  onChangeColor: PropTypes.func,
  onChangeLogo: PropTypes.func,
  onRemoveTeamColorAndImage: PropTypes.func
};

LogoColorPicker.defaultProps = {
  color: "",
  isHomeTeam: false,
  logo: "",
  onBack: ()=> {},
  onChangeColor: ()=> {},
  onChangeLogo: ()=> {},
  onRemoveTeamColorAndImage: () => {}
};

export default LogoColorPicker;
